import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateJob, jobsListSortMap, jobsSearchCols } from "./_helpers";

// returns: list of all open (unclaimed) job openings, regardless of start time
export const unclaimed_jobs: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_jobs_list").select("*").eq("job_status", "open");
  query = applyListParams(query, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "start_date", ascending: true },
        { column: "start_time", ascending: true },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
